module.exports = __webpack_public_path__ + "static/media/filledComment.e040c795.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filledComment.svg
// module id = 39
// module chunks = 0